import React from 'react';
import { chakra, Alert as ChakraAlert } from '@chakra-ui/react';

const Alert = chakra((props) => {
  return <ChakraAlert {...props} variant="subtle" />;
});

export default Alert;
